import { render, staticRenderFns } from "./_market.vue?vue&type=template&id=6ade0a8f"
import script from "./_market.vue?vue&type=script&lang=js"
export * from "./_market.vue?vue&type=script&lang=js"
import style0 from "./_market.vue?vue&type=style&index=0&id=6ade0a8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports